import { API_HOST_NAME } from "../../constants.js";
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js";

const useTeamDeploymentsResources = (teamId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/deployments`;
  return useAuthenticatedResources(url)
}

export default useTeamDeploymentsResources;
